import './FieldWrapper.css';

import { cn } from '##/utils/bem';

export const cnFieldWrapper = cn('FieldWrapper');
